import "./portfolio.css";
import IntroSection from "./Components/IntroSection";
import SkillSet from "./Components/SkillSet";
import ViewResult from "./Components/ViewResults";
import GetInTouch from "./Components/GetInTouch";

function App() {
  return (
    <div>
      <IntroSection />
      <SkillSet />
      <ViewResult />
      <GetInTouch />
    </div>
  );
}

export default App;
